const resource = 'partners'

export default $axios => ({
  fetch(params) {
    return $axios.$get(`/${resource}`, { params })
  },
  get(id, params) {
    return $axios.$get(`/${resource}/${id}`, { params })
  },
  delete(id) {
    return $axios.$delete(`/${resource}/${id}`)
  },
  create(params) {
    return $axios.$post(`/${resource}`, params, {
      headers: { 'content-type': 'multipart/form-data' },
    })
  },
  update(id, params) {
    return $axios.$post(`/${resource}/${id}`, params, {
      headers: { 'content-type': 'multipart/form-data' },
    })
  },
  updateWithPut(id, params) {
    return $axios.$put(`/${resource}/${id}`, params)
  },
  fetchHomeFeatured() {
    return $axios.$get('/v2/home-featured-partners')
  },
  fetchHomeWall() {
    return $axios.$get('/v2/home-partners-wall')
  },
  fetchDirectory() {
    return $axios.$get('/v2/partner-directory')
  },
  fetchMap(params) {
    return $axios.$get('/v2/map-partners', { params })
  },
  getV2(id) {
    return $axios.$get(`/v2/partners/${id}`)
  },
  fetchMine() {
    return $axios.$get('/partners/mine')
  },
  updateMyTypes(partnerTypeIds) {
    return $axios.$put('/partners/mine/types', {
      partner_type_ids: partnerTypeIds,
    })
  },
  fetchTypes() {
    return $axios.$get('/partner_types', {
      params: { sort: 'position', limit: -1 },
    })
  },

  getServiceName: name => 'partnerService',
})
